<!-- TODO: This onboarding page should be removed - video is no longer shown -->
<template>
  <absolutely-layout :enable-scroll-event="false" :show-footer="false">
    <AbsolutelyVideoPlayer
      v-if="videoUrl"
      :video-url="videoUrl"
      id="absolutely-onboarding"
      :show-custom-controls="false"
    />
  </absolutely-layout>
</template>

<script>
import AbsolutelyVideoPlayer from '@/components/Absolutely/AbsolutelyVideoPlayer';
import AbsolutelyAccessMixin from '@/mixins/AbsolutelyAccess';

export default {
  name: 'AbsolutelyOnboarding',
  components: {
    AbsolutelyVideoPlayer,
  },
  mixins: [AbsolutelyAccessMixin],
  data() {
    return {
      videoUrl: '',
    };
  },
  async ionViewWillEnter() {
    // Check access
    if (!(await this.checkAbsolutelyAccess())) return;

    // Get videoUrl from query parameter before view enters
    this.videoUrl = this.$route.query.videoUrl || '';
    if (!this.videoUrl) {
      console.warn('No videoUrl provided, redirecting to home');
      this.$router.replace('/absolutely');
    }
  },
};
</script>
